"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryPasswordRestoreDto = void 0;
class QueryPasswordRestoreDto {
    email;
    url_fallback;
}
exports.QueryPasswordRestoreDto = QueryPasswordRestoreDto;
